import { omitBy, some, zip } from "lodash";

const orderFilter = (it) => it !== "experience" && it !== "summary";
// while csv format supports " and \n and ,  in values, software often struggles with that.
const csvEscape = (str) => `${str || ""}`.replace(/\n|\r/g, "; ").replace(/, ?/g, ";").replace(/"/g, "'");
import { filterForBlindSelection } from "../helpers/blind_csv";

const getContact = (contactInformation, key) =>
  contactInformation
    ?.filter((item) => item.type === key)
    .map((item) => item.value)
    .join("; ");

const profilesToTable = (exportableProfiles, order, options = {}) => {
  const { isBlindModeOn, formatDate } = options;
  const hiddenFields = Object.entries(options?.hidden)
    .filter((item) => item[1] === true)
    .map((item) => item[0]);

  const filteredOrder = order
    .filter((item) => !hiddenFields.includes(item))
    .filter(orderFilter)
    .filter((item) => item !== "stored_as");

  const keyValueCustomTypes = exportableProfiles[0]?.customTypes.reduce(
    (acc, item) => ({ ...acc, [item.name]: item.display_as }),
    {}
  );
  const defaultTableData = {
    "Profinda ID": ({ profile }) => profile.id,
    "Email": ({ profile }) => profile.email,
    "First Name": ({ firstName }) => csvEscape(firstName),
    "Last Name": ({ lastName }) => csvEscape(lastName),
    "Updated At": ({ profile }) => profile.updated_at && formatDate(profile.updated_at),
    "Phone": ({ profile }) => getContact(profile.contact_information, "phone"),
    "Website": ({ profile }) => getContact(profile.contact_information, "website"),
    "Job Title": ({ mainJobTitle }) => csvEscape(mainJobTitle),
    "Company": ({ mainCompany }) => csvEscape(mainCompany)
  };

  const filteredDefaultTableData = omitBy(defaultTableData, (_, key) =>
    hiddenFields.includes(key.toLowerCase())
  );

  let headers = [
    ...Object.keys(filteredDefaultTableData),
    ...filteredOrder.map((item) => keyValueCustomTypes[item] || item)
  ];

  let items = exportableProfiles.map((exportableProfile) => [
    ...Object.values(filteredDefaultTableData).map((func) => func(exportableProfile)),
    ...filteredOrder.map((type) => {
      const cf = exportableProfile.customFields.find((cf) => cf.type.name === type);
      return csvEscape(cf.value || "");
    })
  ]);

  if (options.removeEmptyColumns) {
    const colsAny = zip(...items).map((it) => some(it));
    const EMPTY = {};
    const nullEmptyCol = (text, index) => (colsAny[index] ? text : EMPTY);
    const filterEmpty = (row) => row.map(nullEmptyCol).filter((it) => it !== EMPTY);
    headers = filterEmpty(headers);
    items = items.map(filterEmpty);
  }

  return isBlindModeOn ? filterForBlindSelection([headers, items]) : [headers, items];
};

export default profilesToTable;
